import { Routes, RouterModule } from '@angular/router';
import { PublicLayoutComponent } from './_layout/public-layout/public-layout.component';
import { PrivateLayoutComponent } from './_layout/private-layout/private-layout.component';
import { AuthGuard } from './_guards/auth.guard';
import { LoginComponent } from './login';
import { ChangelogComponent } from './changelog/changelog.component';
import { HammaddeComponent } from './hammadde/hammadde.component';
import { CompoundComponent } from './compound/compound.component';
import { CategoryComponent } from './category/category.component';
import { PropertydefComponent } from './definition/propertydef/propertydef.component';
import { ReportdefComponent } from './definition/reportdef/reportdef.component';
import { ReportsComponent } from './reports/reports.component';
import { NewreportComponent } from './reports/newreport/newreport.component';
import { AddcompoundComponent } from './compound/addcompound/addcompound.component';
import { AllergenComponent } from './allergen/allergen.component';
import { FunctionsComponent } from './functions/functions.component';
import { EditProductComponent } from './reports/edit-product/edit-product.component';

const appRoutes: Routes = [
  // Public layout
  {
    path: '',
    component: PublicLayoutComponent,
    children: [
      { path: 'login', component: LoginComponent },
      { path: '', component: LoginComponent }
    ]
  },
  // Private layout
  {
    path: '',
    component: PrivateLayoutComponent,
    children: [
      { path: 'logout', component: LoginComponent, canActivate: [AuthGuard] },
      { path: 'dashboard', component: ChangelogComponent,
       canActivate: [AuthGuard]
         },
         { path: 'hammadde', component: HammaddeComponent,
          canActivate: [AuthGuard]
            },
            { path: 'compound', component: CompoundComponent,
              canActivate: [AuthGuard]
                },
                { path: 'category', component: CategoryComponent,
                  canActivate: [AuthGuard]
                    },
                    { path: 'property', component: PropertydefComponent,
                      canActivate: [AuthGuard]
                        },
                        { path: 'definition', component: ReportdefComponent,
                          canActivate: [AuthGuard]
                            },
                            { path: 'report', component: ReportsComponent,
                              canActivate: [AuthGuard]
                                },
                                { path: 'newreport', component: NewreportComponent,
                                  canActivate: [AuthGuard]
                                    },
                                    { path: 'newcompound', component: AddcompoundComponent,
                                      canActivate: [AuthGuard]
                                        },
                                        { path: 'allergens', component: AllergenComponent,
                                          canActivate: [AuthGuard]
                                            },
                                            { path: 'functions', component: FunctionsComponent,
                                              canActivate: [AuthGuard]
                                                },
                                                 { path: 'editreport/:id', component: EditProductComponent,
                                              canActivate: [AuthGuard]
                                                },
    ],
  },
  // otherwise redirect to home
  { path: '**', redirectTo: 'dashboard' }
];

export const routing = RouterModule.forRoot(appRoutes, { scrollOffset: [0, 0], scrollPositionRestoration: 'top'});
